import React, { useState } from "react";
import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import * as websocket from "../../utils/communication.js";
import HeizkurveChart from "./HeizkurveChart.jsx";

const Heizkurve = observer((props) => {
  //========================================================================
  // Basename
  const base = props.props.variable;

  // Suffixe
  const VARS = {
    steig: "fSteig",
    kruemm: "fKruemm",
    tempAuslege: "fTempAuslege",
    fremdw: "fFremdw",
    tempVlMin: "fTempVlMin",
    tempVlMax: "fTempVlMax",
    spTempRaum: "fSpTempRaumSimHk",
  };

  // Vollständige Variablennamen erzeugen
  const varNames = Object.fromEntries(
    Object.entries(VARS).map(([key, suffix]) => [key, `${base}.${suffix}`]),
  );

  //========================================================================
  // für Datenpunkte anmelden
  const newReqDataValues = globalVars.reqDataValues;

  for (let i = 0; i < Object.values(varNames).length; i++) {
    if (!newReqDataValues.includes(Object.values(varNames)[i])) {
      newReqDataValues.push(Object.values(varNames)[i]);
    }
  }

  globalVars.setReqDataValues(newReqDataValues);
  websocket.registerDataPoints(
    globalVars.ws,
    globalVars.reqDataValues,
    "register",
  );

  //========================================================================
  // Wert aus globalVars auslesen und parsen
  const readFloat = (name) => parseFloat(rwData.readRcvValue(name)?.value ?? 0);

  const steig = readFloat(varNames.steig);
  const kruemm = readFloat(varNames.kruemm);
  const tempAuslege = readFloat(varNames.tempAuslege);
  const fremdw = readFloat(varNames.fremdw);
  const tempVlMin = readFloat(varNames.tempVlMin);
  const tempVlMax = readFloat(varNames.tempVlMax);
  const spTempRaum = readFloat(varNames.spTempRaum);

  //========================================================================
  // Funktion Heizkurve (Vorlauf mit Krümmung)
  const heizkurve = (tempAuss) => {
    let tempAussen = parseFloat(tempAuss);
    const ln4 = Math.log(4);

    const teil1 = Math.exp(
      Math.log(Math.max(1, spTempRaum - tempAussen - fremdw)) *
        (1 - Math.log(Math.max(1, 1 / ln4 + kruemm)) * (1 / ln4)),
    );

    const teil2 = Math.exp(
      Math.log(Math.max(1, 20 - tempAuslege)) *
        (Math.log(Math.max(1, 1 / ln4 + kruemm)) * (1 / ln4)),
    );

    const vorlauf = teil1 * teil2 * steig + spTempRaum;

    return Math.min(tempVlMax, Math.max(tempVlMin, vorlauf));
  };

  //========================================================================
  // für Werte -15 bis +20
  let data = {
    xValues: [
      -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2,
      3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
    yValues: [],
  };

  //========================================================================
  // den Außentemperaturwerten die berechnete Vorlauftemperatur zuordnen
  data.yValues = data.xValues.map(heizkurve);

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <HeizkurveChart
        data={data}
        xMin={-15}
        xMax={20}
        yMin={20}
        yMax={65}
        xText={"Außentemperatur [°C]"}
        yText={"Vorlauftemperatur [°C]"}
        lineColor={"red"}
        axisColor={"#D4CBCB"}
        tickColor={"#D4CBCB"}
        textColor={"#D4CBCB"}
      />
    </div>
  );
});

export default Heizkurve;
